import { Component, OnInit, Input } from '@angular/core';
import { Course } from 'lms-api';

@Component({
  selector: 'app-thumbnail-highlight',
  templateUrl: './thumbnail-highlight.component.html',
  styleUrls: ['./thumbnail-highlight.component.scss']
})
export class ThumbnailHighlightComponent implements OnInit {
  @Input() course: Course;

  constructor() { }

  ngOnInit() {
  }

}
